export const UPDATE_SESSION_ID = "UPDATE_SESSION_ID";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_SESSION_ID = "DELETE_SESSION_ID";
export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const UPDATE_FAVORITES = "UPDATE_FAVORITES";
export const UPDATE_WATCHLIST = "UPDATE_WATCHLIST";
